import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { Observable } from "rxjs";
import { ERTEducation } from "../../interfaces/ert-education/ert-education";
import { FormGroup } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class EducationService {
  private apiUrl = environment.apiUrl + "/education";
  constructor(private http: HttpClient) { }

  public getEducation(facilityId : Number): Observable<ERTEducation[]> {
    return this.http.get<ERTEducation[]>(`${this.apiUrl}/getAllEducations/${facilityId}`);
  }

  public getEducationById(educationId: number, facilityId : Number) {
    return this.http.get<ERTEducation>(`${this.apiUrl}/${educationId}?loggedInUserFacilityId=${facilityId}`);
  }

  public updateEducation(education: ERTEducation, facilityId : Number) {
    return this.http.put(`${this.apiUrl}/${education.id}?loggedInUserFacilityId=${facilityId}`, education);
  }
  public deleteEducation(id: number, facilityId : Number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}?loggedInUserFacilityId=${facilityId}`);
  }

  public editEducation(kr: ERTEducation): Observable<any> {
    return this.http.put(`${this.apiUrl}/${kr.id}`, kr);
  }

  public saveEducation(education: ERTEducation): Observable<ERTEducation> {
    return this.http.post<ERTEducation>(this.apiUrl, education);
  }

  public getUserEducationByUserId(userId: number): Observable<ERTEducation[]> {
    return this.http.get<ERTEducation[]>(`${this.apiUrl}/user/${userId}`);
  }

  public validate(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("name")?.value) {
      errors.push("Name is required");
    }
    return errors;
  }

  validateViewForm(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("schoolAttended")?.value || form.get("schoolAttended")?.value === "-1") {
      errors.push("School Attended is required");
    }
    if (!form.get("schoolDivision")?.value || form.get("schoolDivision")?.value === "-1") {
      errors.push("School Division is required");
    }
    if (!form.get("attendanceDate")?.value) {
      errors.push("Attendance Date is required");
    }
    if (!form.get("hours")?.value) {
      errors.push("Hours is required");
    }
    if (!form.get("onOffSite")?.value) {
      errors.push("On/Off Site is required");
    }
    if (!form.get("facilityName")?.value) {
      errors.push("Facility is required");
    }
    return errors;
  }

  validateForm(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("schoolAttended")?.value || form.get("schoolAttended")?.value === "-1") {
      errors.push("School Attended is required");
    }
    if (!form.get("schoolDivision")?.value || form.get("schoolDivision")?.value === "-1") {
      errors.push("School Division is required");
    }
    if (!form.get("hours")?.value) {
      errors.push("Hours Attended is required");
    }
    if (!form.get("onOffSite")?.value) {
      errors.push("On/Off Site is required");
    }
    if (!form.get("attendanceDate")?.value) {
      errors.push("Attendance Date is required");
    }
    return errors;
  }

  validateCreateForm(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("userErt.fullName")?.value) {
      errors.push("ERT User is required");
    }
    return errors;
  }
}
